import Base from '@/libs/core/Base'

export const fields = {
    paybillNo: '',
    organisationName: '',
    consumerSecret: '',
    consumerKey: '',
    confirmationUrl: '',
    passKey: '',
    validationUrl: '',
    stkCallbackUrl: '',
}

export default class PayBill extends Base {
  constructor () {
    super(fields)
  }
  
  store () {
    return new Promise(async (resolve, reject) => {
      try {
        let response = await this.form.submit('post', 'payments/mpesa/configure-paybill', this.getFields())
        this.setFields(fields)
        flash(response)
        resolve(response)
      } catch (err) {
        reject(err)
      }
    })
  }
}